import OtpRepository from '@/js/repositories/OtpRepository'
import { Strings } from "@/js/commons/strings"
import i18n from "@/lang/i18n"

const state = {
	errorMsg: '',
	fcmToken: '',
	otpLoading: false,
	otpAccessToken: null,
	otpCode: null,
	statusOTP: null,
	childId: null,
	isAllowed: false
}

const getters = {
}

const actions = {
	initLogout({ commit }) {
		commit('INIT')
	},
	setFcmToken({ commit }, data) {
		commit('FCM_TOKEN', data)
	},
	setOtpLoading({ commit }, data) {
		commit('OTP_LOADING', data)
	},
	setOtpAccessToken({ commit }, data) {
		commit('OTP_ACCESS_TOKEN', data)
	},
	setErrorMsg({ commit }, data) {
		commit('OTP_ERROR', data)
	},
	async inputOtp({ commit }, data) {
		commit('OTP_LOADING', false)
		await OtpRepository.inputOtp(data)
			.then(res => {
				const { isAllowed, child_id, one_time_access_key } = res.data.data
				if (isAllowed) {
					commit('CHILD_ID', child_id)
				}
				else {
					commit('OTP_LOADING', true)
					commit('OTP_CODE', data.otp)
				}
				commit('ISALLOWED', isAllowed)
				commit('OTP_ACCESS_TOKEN', one_time_access_key)
				commit('OTP_ERROR', '')
			})
			.catch(error => {
				let messageError = error.response.data.message[0]
				let isInvalidOTP = error.response.status === 422
				if (isInvalidOTP)
					commit('OTP_ERROR', messageError)
				else
					commit('OTP_ERROR', i18n.t('the_otp_is_incorrect'))
			})
	},
	onRecieveFCM({ commit }, data) {
		commit('OTP_LOADING', data.isLoading)
		commit('OTP_ACCESS_TOKEN', data.otpAccessToken)
	},
	async getStatusOTP({ commit }, data) {
		await OtpRepository.getStatusOTP(data)
			.then(res => {
				const { accept_flg, one_time_access_key, child_id } = res.data.data
				if (accept_flg === 0 || accept_flg === 1) {
					commit('OTP_LOADING', false)
					commit('OTP_CODE', null)
				}
				commit('OTP_ACCESS_TOKEN', one_time_access_key)
				commit('CHILD_ID', child_id)
				commit('STATUS_OTP', accept_flg)
			})
			.catch(error => {
				console.log(error.response)
			})
	},
	async cancelOTP({ commit }, data) {
		await OtpRepository.cancelOTP(data)
			.then(res => {
				commit('CANCEL_OTP')
			})
			.catch(error => {
				console.log(error.response)
				commit('CANCEL_OTP')
			})
	},
}

const mutations = {
	INIT(state) {
		state.fcmToken = '',
		state.otpLoading = false,
		state.otpAccessToken = null
		state.errorMsg = ''
	},
	OTP_ERROR(state, errMsg) {
		state.errorMsg = errMsg
	},
	FCM_TOKEN(state, data) {
		state.fcmToken = data
	},
	OTP_ACCESS_TOKEN(state, data) {
		state.otpAccessToken = data
	},
	OTP_LOADING(state, data) {
		state.otpLoading = data
	},
	STATUS_OTP(state, data) {
		state.statusOTP = data
	},
	OTP_CODE(state, data) {
		state.otpCode = data
	},
	CANCEL_OTP(state) {
		state.otpAccessToken = null,
		state.statusOTP = null,
		state.otpCode = null,
		state.otpLoading = false
	},
	CHILD_ID(state, childId) {
		state.childId = childId
	},
	ISALLOWED(state, bool) {
		state.isAllowed = bool
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
